export default __webpack_public_path__ + "static/media/logoAffinitiiFontWhite.fecc4381.png";